export default __webpack_public_path__ + "static/media/creative.175fa3e0.png";